import { render, staticRenderFns } from "./CourseBatch.vue?vue&type=template&id=4b6b11fb&scoped=true"
import script from "./CourseBatch.vue?vue&type=script&lang=js"
export * from "./CourseBatch.vue?vue&type=script&lang=js"
import style0 from "./CourseBatch.vue?vue&type=style&index=0&id=4b6b11fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b11fb",
  null
  
)

export default component.exports